import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { PluginType } from '../../components/plugins/types';
import useUserLanguage from '../../hooks/useUserLanguage';
import { getSupportedLanguagesWithName } from '../../services/apps/plugins';
import { usePluginStore } from '../../store/RootStoreContext';

export default observer(function TranslatePluginContainer() {
    const {
        translatePlugin,
        pluginsErrors: { TRANSLATE: translatePluginErrors },
        pluginIsInitializing: { TRANSLATE: translatePluginIsInitializing },
        setPluginIsInitializing,
        setTranslateLanguageOptions
    } = usePluginStore();
    const { data: language } = useUserLanguage();

    const pluginId = translatePlugin?.pluginId;
    const isInitializing = translatePluginIsInitializing?.[pluginId] ?? true;
    const error = translatePluginErrors?.[pluginId] ?? null;
    const apiKey = translatePlugin?.settings['apiKey'];

    useEffect(() => {
        if (pluginId) {
            setPluginIsInitializing(pluginId, PluginType.TRANSLATE, !apiKey);
        }
    }, [apiKey, pluginId, setPluginIsInitializing]);
    useEffect(() => {
        if (!error && apiKey && language && !isInitializing)
            getSupportedLanguagesWithName(apiKey, language).then((languages) => setTranslateLanguageOptions(languages));
    }, [apiKey, error, isInitializing, language, setTranslateLanguageOptions]);

    return null;
});
